module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_hamamatsu-c0de2a1bfeb700f11c5ff361e938d4f7.jpg";